module.exports = __webpack_public_path__ + "img/YT-UNF.1d7c6690.svg";